import React, {useEffect, useState} from "react";



export const Iframe = (props) => {
    const sc = props.slice.primary;


    const [ setHeight ] = useState("0");

    useEffect(() => {
        
        const iframe = document.getElementById("frame");
          setHeight(iframe.offsetHeight);
      }, []);
    
      

      

    return (
        <section className="gutter sm">
            <div className="wrapper">
            <iframe title="iframe" id="frame" width="100%" height="1350px" src={sc.source} />
            </div>
        </section>
    )
}